'use-client';
import * as React from 'react';
import type {
  ITimePickerProps,
  ITimePickerImperativeActions,
} from '../../../TimePicker.types';
import TimePickerBase from '../../TimePickerBase';
import TimePickerDropdownBase from './TimePickerDropdownBase';

const TimePickerDropdown: React.ForwardRefRenderFunction<
  ITimePickerImperativeActions,
  ITimePickerProps
> = (props, ref) => {
  return (
    <TimePickerBase
      {...props}
      ControllerComponent={TimePickerDropdownBase}
      ref={ref}
    ></TimePickerBase>
  );
};

export default React.forwardRef(TimePickerDropdown);
